'use client';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import HeroSection from './components/HeroSection';
import AntiFluffStatement from './components/AntiFluffStatement';
import ServicesPreview from './components/ServicesPreview';
import MetricsBar from './components/MetricsBar';
import ClosingCTA from './components/ClosingCTA';
import { useLanguage } from '@/contexts/LanguageContext';

export default function Homepage() {
  const { language } = useLanguage();

  return (
    <>
      <Header />
      <main className="min-h-screen">
        <HeroSection language={language} />
        <AntiFluffStatement language={language} />
        <ServicesPreview language={language} />
        <MetricsBar language={language} />
        <ClosingCTA language={language} />
      </main>
      <Footer />
    </>
  );
}